import apiClient from '../../../shared/config/axios'
import { ArbeitszeitReportFilters, ArbeitszeitReportResponse } from '@myapp/contract'

export const arbeitszeitReportApi = {
  search: (params: ArbeitszeitReportFilters) =>
    apiClient.get<ArbeitszeitReportResponse>('/arbeitszeit-report', { params }),
}
